import * as React from 'react';

import { Center, TableCellProps, VStack, Box, HStack, Table, Text, Spinner } from '@chakra-ui/react';
import { Res } from 'core/api';
import { SvgIcon } from 'core/ui-next';
import * as Images from 'pos/Images';
import { TableProps } from './types';




export function PhoneSearchCustomerTable(props: TableProps): React.ReactNode {

	const { customers, selectedCustomer, onSelectCustomer, loading, searchResultInfo, MAX_CUSTOMERS_TO_FIND } = props;

	return <Table.ScrollArea w={'full'} maxH={'100'} rounded={'md'} >
		<Table.Root striped interactive stickyHeader>
			<Table.Header>
				<Table.Row>
					<Table.ColumnHeader w={'50'} minW={'50'} maxW={'50'} textAlign={'start'}>
						<Text fontSize={'sm'} fontWeight={'semibold'}>{Res.Web.SET_BUYER_CUSTOMER_CUSTOMERS_CLM()}</Text>
					</Table.ColumnHeader>
					<Table.ColumnHeader w={'29'} minW={'29'} maxW={'29'} textAlign={'end'}>
						<Text fontSize={'sm'} fontWeight={'semibold'}>{Res.Web.SET_BUYER_CUSTOMER_CIF_CLM()}</Text>
					</Table.ColumnHeader>
				</Table.Row>
			</Table.Header>
			<Table.Body>
				{loading ?
					<Table.Row h={'full'}>
						<Table.Cell colSpan={2}>
							<Center>
								<Spinner color={{ base: '{colors.yellow.500}', _dark: '{colors.yellow.500}' }} h={'12'} w={'12'} borderWidth={'medium'} />
							</Center>
						</Table.Cell>
					</Table.Row>
					: customers.length === 0 && searchResultInfo !== '' ?
						<Table.Row h={'full'}>
							<Table.Cell colSpan={2}>
								<Text>{searchResultInfo}</Text>
							</Table.Cell>
						</Table.Row>
						: <>
							{customers.length >= MAX_CUSTOMERS_TO_FIND && searchResultInfo !== '' &&
								<Table.Row h={'full'}>
									<Table.Cell colSpan={2}>
										<Text>{searchResultInfo}</Text>
									</Table.Cell>
								</Table.Row>}
							{customers.map((customer, index) => {
								const cellBackGround: TableCellProps['bg'] = selectedCustomer !== null && selectedCustomer.Id === customer.Id ? { base: '{colors.blue.200}', _dark: '{colors.blue.500}' } : undefined;

								const hasBusinessName = customer.BusinessName !== '' && customer.BusinessName !== null && customer.BusinessName !== undefined;
								const hasContactPerson = customer.ContactPerson !== '' && customer.ContactPerson !== null && customer.ContactPerson !== undefined;
								const hasAddress = customer.Address.Street !== '' && customer.Address.City !== '' && customer.Address.ZipCode !== '' && customer.Address.Region !== ''
									&& customer.Address !== null && customer.Address !== undefined;
								const hasTelephone = customer.Telephone !== '' && customer.Telephone !== null && customer.Telephone !== undefined;

								return (
									<Table.Row key={index} h={'full'} onClick={() => onSelectCustomer(customer)}>
										<Table.Cell bg={cellBackGround} w={'50'} minW={'50'} maxW={'50'} textAlign={'start'} verticalAlign={'top'}>
											<VStack gap={'1'} alignItems={'start'} justifyContent={'start'}>
												<Box><Text fontSize={'sm'} lineClamp={1}>{customer.FiscalName}</Text></Box>
												{hasBusinessName &&
													<HStack gap={'1'} justifyContent={'start'}>
														<SvgIcon src={Images.Shop} width={'4'} height={'4'} minW={'4'} minH={'4'} />
														<Text fontSize={'xs'} lineClamp={1}>{customer.BusinessName}</Text>
													</HStack>
												}
												{hasAddress &&
													<HStack gap={'1'} justifyContent={'start'}>
														<SvgIcon src={Images.Location} width={'4'} height={'4'} minW={'4'} minH={'4'} />
														<Text fontSize={'xs'} lineClamp={1}>{customer.Address.Street + ' ' + customer.Address.City + ' ' + customer.Address.ZipCode}</Text>
													</HStack>
												}
											</VStack>
										</Table.Cell>
										<Table.Cell bg={cellBackGround} w={'29'} minW={'29'} maxW={'29'} verticalAlign={'top'}>
											<VStack gap={'1'} alignItems={'stretch'} justifyContent={'start'} w={'full'}>
												<Box textAlign={'end'}><Text fontSize={'sm'}>{customer.Cif}</Text></Box>
												{hasContactPerson &&
													<HStack gap={'1'} justifyContent={'start'}>
														<SvgIcon src={Images.User} width={'4'} height={'4'} minW={'4'} minH={'4'} />
														<Text fontSize={'xs'} lineClamp={1}>{customer.ContactPerson}</Text>
													</HStack>
												}
												{hasTelephone &&
													<HStack gap={'1'} justifyContent={'start'}>
														<SvgIcon src={Images.Phone} width={'4'} height={'4'} minW={'4'} minH={'4'} />
														<Text fontSize={'xs'} lineClamp={1}>{customer.Telephone}</Text>
													</HStack>
												}
											</VStack>
										</Table.Cell>
									</Table.Row>
								);
							})}
						</>
				}
			</Table.Body>
		</Table.Root>
	</Table.ScrollArea>;
}
